require('./dist/js/xeditable.js');
module.exports = 'xeditable';
